import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import Header from './Header';
import Home from '../pages/Home';
import Clients from '../pages/Clients/Clients';
import Client from '../pages/Clients/Client';
import Mavs from '../pages/Mavs/Mavs';
import Reviews from '../pages/Mavs/Reviews';
import Quotes from '../pages/Quotes/Quotes';
import Messages from '../pages/Messages/Messages';
import Message from '../pages/Messages/Message';
import Navigation from './Navigation';
import Logout from '../pages/Authentication/Logout';
import SignIn from '../pages/Authentication/SignIn';
import NotFound from '../pages/NotFound';
import { mavMode } from '../../config/env';
import { devModeNotice_admin } from '../../config/messages';
import PushNotifications from '../pages/PushNotification/PushNotifications';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import ReportsDashboard from '../pages/reports/ReportsDashboard';
import RptBookingCancelled from '../pages/reports/RptBookingCancelled';
import RptAccountDeletions from '../pages/reports/RptAccountDeletions';
import RptMembershipCancelled from '../pages/reports/RptMembershipCancelled';
import Discount from '../pages/Discount/Discount';
import Referrals from '../pages/Referrals/Referrals';
import Transfers from '../pages/Transfer/Transfers';
import Conversations from '../pages/Conversations/Conversations';
import Support from '../pages/Support/Support';
import SupportChat from '../pages/Support/SupportChat';
import IssuesResolution from '../pages/IssuesResolution/IssuesResolution';
import RptAnalytics from '../pages/reports/analytics/ RptAnalytics';
import RptNotification from '../pages/reports/notification/RptNotification';
import RptMonthly from '../pages/reports/monthlyReport/RptMonthly';
import Jobs from '../pages/Jobs/Jobs';
import Job from '../pages/Jobs/Job';
import Mav from '../pages/Mavs/Mav';
import Quote from '../pages/Quotes/Quote';

const initialUserDetails = {
	jwttoken: null,
	accountInfo: {
		firstname: null,
		surname: null,
		username: null,
		email: null,
		dob: null,
		telephone: null,
		settings: {
			pushnotifications: null
		}
	},
	myJobs: {},
	myQuotes: {},
	messages: {},
	userType: null,
	short_id: null
};

const Router = ({ appMode }) => {
	const [userDetails, setUserDetails] = useState(initialUserDetails);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const localStorageRef = localStorage.getItem('userDetailsAdmin');
		if (localStorageRef) {
			setUserDetails(JSON.parse(localStorageRef));
		}
		setIsLoading(false);
	}, []);

	useEffect(() => {
		localStorage.setItem('userDetailsAdmin', JSON.stringify(userDetails));
	}, [userDetails]);

	const updateState = (stateLabel, stateObject, theCallback) => {
		if (stateLabel === 'userDetails') {
			if (!_.isEqual(stateObject, userDetails)) {
				setUserDetails(stateObject);
				if (theCallback) {
					theCallback();
				}
			}
		}
	};

	const logOut = (logOutCallbackFunc) => {
		setUserDetails(initialUserDetails);
	};

	if (isLoading) {
		return (
			<BrowserRouter>
				<main className="l-base-layout" />
			</BrowserRouter>
		);
	}

	let loggedIn = false;
	if (userDetails.jwttoken != null && userDetails.accountInfo.username != null) {
		loggedIn = true;
	}

	return (
		<BrowserRouter>
			<main className="l-base-layout">
				<Navigation
					userDetails={userDetails}
					updateState={updateState}
					logOut={logOut}
					appMode={appMode}
				/>

				{loggedIn ? (
					<Routes>
						<Route path="/" element={<Home userDetails={userDetails} updateState={updateState} appMode={appMode} />} />
						<Route path="/signin" element={<SignIn userDetails={userDetails} updateState={updateState} />} />
						<Route path="/clients" element={<Clients userDetails={userDetails} updateState={updateState} />} />
						<Route path="/client/:clientId" element={<Client userDetails={userDetails} updateState={updateState} />} />
						<Route path="/mavs" element={<Mavs userDetails={userDetails} updateState={updateState} />} />
						<Route path="/mav/:mavId/reviews" element={<Reviews userDetails={userDetails} updateState={updateState} />} />
						<Route path="/mav/:mavId" element={<Mav userDetails={userDetails} updateState={updateState} />} />
						<Route path="/jobs" element={<Jobs userDetails={userDetails} updateState={updateState} />} />
						<Route path="/job/:jobId" element={<Job userDetails={userDetails} updateState={updateState} />} />
						<Route path="/quotes" element={<Quotes userDetails={userDetails} updateState={updateState} />} />
						<Route path="/quote/:quoteId" element={<Quote userDetails={userDetails} updateState={updateState} />} />
						<Route path="/conversations" element={<Conversations userDetails={userDetails} updateState={updateState} />} />
						<Route path="/support" element={<Support userDetails={userDetails} updateState={updateState} />} />
						<Route path="/conversation/:type/:userId" element={<SupportChat userDetails={userDetails} updateState={updateState} />} />
						<Route path="/messages" element={<Messages userDetails={userDetails} updateState={updateState} />} />
						<Route path="/transfers" element={<Transfers userDetails={userDetails} updateState={updateState} />} />
						<Route path="/message/:userId/:secondUserId" element={<Message userDetails={userDetails} updateState={updateState} />} />
						<Route path="/message/:userId" element={<Message userDetails={userDetails} updateState={updateState} />} />
						<Route path="/issues-resolutions" element={<IssuesResolution userDetails={userDetails} updateState={updateState} />} />
						<Route path="/reports" element={<ReportsDashboard userDetails={userDetails} updateState={updateState} />} />
						<Route path="/reports/monthly" element={<RptMonthly userDetails={userDetails} updateState={updateState} />} />
						<Route path="/reports/booking-cancellations" element={<RptBookingCancelled userDetails={userDetails} updateState={updateState} />} />
						<Route path="/reports/account-deletions" element={<RptAccountDeletions userDetails={userDetails} updateState={updateState} />} />
						<Route path="/reports/membership-cancellations" element={<RptMembershipCancelled userDetails={userDetails} updateState={updateState} />} />
						<Route path="/reports/analytics-report" element={<RptAnalytics userDetails={userDetails} updateState={updateState} />} />
						<Route path="/reports/notification" element={<RptNotification userDetails={userDetails} updateState={updateState} />} />
						<Route path="/pushNotifications" element={<PushNotifications userDetails={userDetails} updateState={updateState} />} />
						<Route path='/discounts' element={<Discount userDetails={userDetails} updateState={updateState} />} />
						<Route path='/referrals' element={<Referrals userDetails={userDetails} updateState={updateState} />} />
						<Route path="/logout" element={<Logout userDetails={userDetails} updateState={updateState} logOut={logOut} />} />
						<Route path="*" element={<NotFound />} />
					</Routes>
				) : (
					<Routes>
						<Route path="/signin" element={<SignIn userDetails={userDetails} updateState={updateState} />} />
						<Route path="*" element={<SignIn userDetails={userDetails} updateState={updateState} />} />
						<Route path="*" element={<NotFound />} />
					</Routes>
				)}

				{mavMode == 'dev' ? <div className="dev-mode-notice-admin" onClick={(e) => { e.preventDefault(); alert('This app is in development mode\n\n' + devModeNotice_admin); }}><div></div><span className="u-before-icon-exclamation">&nbsp;&nbsp;DEVELOPMENT MODE</span>&nbsp;&nbsp;(<span className="u-text-decoration-underline">INFO</span>)</div> : null}
			</main>
		</BrowserRouter>
	);
};

Router.propTypes = {
	appMode: PropTypes.string.isRequired
}

export default Router;